import { toast } from "react-toastify";
import { GET } from "./axios.service";
import { t } from "../locales";

type Params = Record<string, any>;

export async function exportModuleReport(
  endpoint: string,
  params: Params,
  toastStyles: any,
  setLoading: (b: boolean) => void,
  dateRangeRequiredMsg?: string,
  options: { requireDateRange?: boolean } = {}
): Promise<void> {
  const { requireDateRange = true } = options;
  if (requireDateRange && (!params.fromDate || !params.toDate)) {
    const msg = dateRangeRequiredMsg ?? "Please select both From Date and To Date.";
    toast.error(msg, { ...(toastStyles as any) });
    return;
  }

  setLoading(true);
  try {
    const response: any = await GET(endpoint, params);
    if (response?.data?.status === "success") {
      const downloadLink = response.data.data?.download_link;
      if (downloadLink) {
        try {
          const newWindow = window.open(downloadLink, "_blank");
          if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
            window.location.href = downloadLink;
          }
        } catch (e) {
          window.location.href = downloadLink;
        }
      } else {
        toast.error(t.common.reportFileNotAvailable, { ...(toastStyles as any) });
      }
    } else {
      toast.error(
        response?.data?.message || t.common.somethingWentWrong,
        { ...(toastStyles as any) }
      );
    }
  } catch (error: any) {
    toast.error(
      error?.response?.data?.message || error?.message || t.common.somethingWentWrong,
      { ...(toastStyles as any) }
    );
  } finally {
    setLoading(false);
  }
}
